import { AxiosInstance } from 'axios';
import { authInterceptor } from './interceptor';
import { AuthInterceptorConfig } from './types';


export const applyAuthInterceptor = (axios: AxiosInstance, config: AuthInterceptorConfig): void => {
  if (!axios.interceptors) throw new Error(`invalid axios instance: ${axios}`)

  axios.interceptors.request.use(authInterceptor(config));
}